import React from "react";
import PropTypes from "prop-types";
import { GOOGLE_MAP_SETTINGS } from "@constants";
import GoogleMap from "google-map-react";
import { Image, MapMarker } from "../../../../components";

class Summary extends React.Component {
	listItemCallBack = (object, index) => {
		if (object.type === "subtitle") {
			return (
				<div
					className="list-element"
					key={index}
				>
					<div className="col">
						<h4>{object.value}</h4>
					</div>
				</div>
			);
		}

		if (object.type === "location" && object.coordinates.lat && object.coordinates.lng) {
			return (
				<div
					className="map-wrapper"
					key={index}
				>
					<div className="map">
						<GoogleMap
							zoom={15}
							center={object.coordinates}
							bootstrapURLKeys={{ key: GOOGLE_MAP_SETTINGS.key }}
							options={GOOGLE_MAP_SETTINGS}
						>
							<MapMarker
								lat={object.coordinates.lat}
								lng={object.coordinates.lng}
							/>
						</GoogleMap>
					</div>
					<span className="address">{object.address}</span>
				</div>
			);
		}

		if (object.type === "picture") {
			return (
				<div
					className="margin-bottom-10"
					key={index}
				>
					<Image
						src={object.url}
						className="img-avatar-xlg img-circle"
						fallbackSrc="avatar"
					/>
				</div>
			);
		}

		return (
			<div
				className="list-element"
				key={index}
			>
				<div className="col">{object.key}</div>
				<div className="col">{object.value}</div>
			</div>
		);
	};

	render() {
		const { leftList: LList, rightList: RList, title } = this.props;
		const leftList = LList.map(this.listItemCallBack);
		const rightList = RList.map(this.listItemCallBack);

		return (
			<div className="panel-summary">
				<div className="col">
					<div className="font-size-24 margin-bottom-10">{title || ""}</div>
					<div className="list-wrapper">{leftList}</div>
				</div>
				<div className="col">
					<div className="list-wrapper">{rightList}</div>
				</div>
			</div>
		);
	}
}

Summary.propTypes = {
	title: PropTypes.string,
	leftList: PropTypes.array.isRequired,
	rightList: PropTypes.array.isRequired,
};

Summary.defaultProps = {
	title: "",
};

export default Summary;
